<template>
  <b-row
    class="w-100 h-100 text-white text-center"
    align-v="center"
    data-cy="notfound-row"
  >
    <b-col data-cy="notfound-col">
      <h1 data-cy="notfound-title-code">404</h1>
      <h1 data-cy="notfound-title">Página não Encontrada</h1>
      <p data-cy="notfound-separator"></p>
      <h4 data-cy="notfound-message">
        A página que você está acessando não foi encontrada.
        <p data-cy="notfound-message-separator"></p>
        <b-button
          class="p-3 mt-4 rounded-0 btn-outline-primary"
          variant="light"
          @click="$router.back()"
          data-cy="notfound-btn-tentar-novamente"
        >
          Tentar Novamente
        </b-button>
      </h4>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "not-found"
};
</script>

<style></style>
